import EditLesson from "../EditLesson"
import { Field } from "formik"
import { LessonResponse } from "shared/lessons"
import styles from "../styles.module.scss"
import ImageLibrary from "components/Editing/ImageLibrary"
import { useState } from "react"
import Button from "react-bootstrap/Button"

const LessonSpecificBackground = ({ lesson, refreshLesson }: { lesson: LessonResponse, refreshLesson: () => Promise<void> }) => {
    const editing = process.env.REACT_APP_EDITING === "true"
    const [modal, setModal] = useState<string>(null)

    return (
        <div>
            <p className="text-start" dangerouslySetInnerHTML={{ __html: lesson?.background }}></p>
            {editing && <div>
                <ImageLibrary modal={modal} setModal={setModal} />
                <EditLesson text="Edit Lesson Background" lesson={lesson} callback={refreshLesson} size="xl">
                    <Button className="mt-3" onClick={() => setModal("imageLibrary")}>Image Library</Button>
                    <br />
                    <Field as={'textarea'} name="lessonBackground" defaultValue={lesson?.background} placeholder="Write Lesson Background" className={`${styles.lessonInput} col-10`} rows={20} />
                </EditLesson>
            </div>}
        </div>
    )
}

export default LessonSpecificBackground
